import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import { useState } from "react";
import { requestSyncUnprocessedAcadReinforce } from "services/acadReinforce/aboutAcadReinforce";
import useMainContext from "utils/context/useMainContext";

const ERRORS = {
    NO_REQUEST_PENDING: "SIN_PETICION_PEND"
};

const useSyncOfAcadReinforceUnprocessed = ({
    setCanShowDialogLeavingView,
}) => {
    const mainContext = useMainContext();
    //#region States
    const [inSyncOfAcadReinforceUnprocessed, setInSyncOfAcadReinforceUnprocessed] = useState(false);
    const [syncAcadReinforceUnprocessedData, setSyncAcadReinforceUnprocessedData] = useState(null);
    const [notExistPendingRecords, setNotExistPendingRecords] = useState(false);
    //#endregion
    const dialogShowSuccessNotification = useShowDialogAlert();
    //#region Functions
    const doSync = async () => {
        setCanShowDialogLeavingView(true);
        setInSyncOfAcadReinforceUnprocessed(true);
        const data = await requestSyncUnprocessedAcadReinforce();
        setInSyncOfAcadReinforceUnprocessed(false);
        setCanShowDialogLeavingView(false);
        // Error de petición
        if (!data) {
            mainContext.setShowDialogUnexpectedError(true);
            return;
        }
        // Sincronización correcta
        if (!data.message) {
            setSyncAcadReinforceUnprocessedData(data);
            dialogShowSuccessNotification.toggle();
            return;
        }
        // Errores controlados
        switch (data.message) {
            case ERRORS.NO_REQUEST_PENDING:
                mainContext.setDialogUnexpectedErrorMessage("No hay peticiones pendientes por actualizar.");
                setNotExistPendingRecords(true);
                break;
            default: break;
        }
        mainContext.setShowDialogUnexpectedError(true);
    }
    //#endregion
    return {
        doSync, inSync: inSyncOfAcadReinforceUnprocessed,
        notExistPendingRecords,
        data: syncAcadReinforceUnprocessedData,
        dialogShow: dialogShowSuccessNotification
    };
}

export default useSyncOfAcadReinforceUnprocessed;